import { defineSagaForService } from '@repo/core'
import { getMailingRelatedProducts } from '@repo/user-services'
import { mailingAddressRelatedProductsDataActions } from '../../slices'

export const mailingAddressRelatedProductsServiceConfig = defineSagaForService({
  [mailingAddressRelatedProductsDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getMailingRelatedProducts,
    actionTypeResponse: mailingAddressRelatedProductsDataActions.getResponse.type,
    actionTypeRequest: mailingAddressRelatedProductsDataActions.getRequest.type,
  },
  [mailingAddressRelatedProductsDataActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getMailingRelatedProducts,
    actionTypeResponse: mailingAddressRelatedProductsDataActions.refreshResponse.type,
    actionTypeRequest: mailingAddressRelatedProductsDataActions.refreshRequest.type,
  },
})
